// Skill/power icons (monorail-ntj) — stroke-drawn SVG ink glyphs replacing the
// single-letter placeholders. Deliberately slightly asymmetric paths so they read
// as pen sketches, not icon-font geometry. Color comes from CSS `currentColor`; the
// power tint stays on the chip background, the glyph stays ink.
//
// The glyphs are authored as standalone .svg files under assets/icons/skill/ and
// imported as raw strings via Vite's `?raw` query (extraction: monorail-42s). Each
// file bakes in the shared wrapper attributes (viewBox 0 0 24 24, fill=none,
// stroke=currentColor, round caps), so `skillIconSvg` just returns the raw markup.

import type { PowerId } from '../game/powers'

import dashSvg from '../assets/icons/skill/dash.svg?raw'
import portalSvg from '../assets/icons/skill/portal.svg?raw'
import axopodSvg from '../assets/icons/skill/axopod.svg?raw'
import membraneLockSvg from '../assets/icons/skill/membrane-lock.svg?raw'
import hypertrophySvg from '../assets/icons/skill/hypertrophy.svg?raw'
import osmoticReachSvg from '../assets/icons/skill/osmotic-reach.svg?raw'
import endosymbiontSvg from '../assets/icons/skill/endosymbiont.svg?raw'
import flagellateSvg from '../assets/icons/skill/flagellate.svg?raw'
import autophagySvg from '../assets/icons/skill/autophagy.svg?raw'
import sporulationSvg from '../assets/icons/skill/sporulation.svg?raw'
import galvanismSvg from '../assets/icons/skill/galvanism.svg?raw'

export type SkillIconId = PowerId | 'dash' | 'portal'

const ICON_SVG: Record<SkillIconId, string> = {
  'dash': dashSvg,
  'portal': portalSvg,
  'axopod': axopodSvg,
  'membrane-lock': membraneLockSvg,
  'hypertrophy': hypertrophySvg,
  'osmotic-reach': osmoticReachSvg,
  'endosymbiont': endosymbiontSvg,
  'flagellate': flagellateSvg,
  'autophagy': autophagySvg,
  'sporulation': sporulationSvg,
  'galvanism': galvanismSvg,
}

/** Inline SVG markup for a skill icon; sized by the parent via CSS. */
export function skillIconSvg(id: SkillIconId): string {
  return ICON_SVG[id]
}
